/*
 * Kleurknopjes onder een productkaartje in een overzicht.
 *
 * Klik je op een kleur, dan:
 *   - wisselt de foto van dat kaartje naar de foto van die kleur
 *   - gaan de links van dat kaartje naar het artikel mét die kleur al gekozen
 *
 * Er wordt niets herladen; het gebeurt meteen in de pagina. De keuze geldt alleen
 * voor dat ene kaartje.
 */
(function () {
  function kaartVan(knop) {
    return knop.closest('.card-wrapper') || knop.closest('.grid__item');
  }

  function wisselFoto(kaart, knop) {
    var foto = knop.dataset.kmFoto;
    if (!foto) return;

    var afbeelding = kaart.querySelector('.card__media img');
    if (!afbeelding) return;

    var groot = knop.dataset.kmFotoGroot || foto;
    afbeelding.setAttribute('srcset', foto + ' 533w, ' + groot + ' 1066w');
    afbeelding.setAttribute('src', foto);
  }

  // De tweede foto is de foto die je bij zweven ziet: de achterkant. Die moet bij
  // dezelfde kleur horen als de voorkant. Heeft een kleur geen achterkant-foto, dan
  // wordt de tweede foto verborgen — anders zie je de achterkant van een andere kleur.
  function wisselAchterkant(kaart, knop) {
    var fotos = kaart.querySelectorAll('.card__media img');
    if (fotos.length < 2) return;

    var tweede = fotos[1];
    var achter = knop.dataset.kmFotoAchter;

    if (achter) {
      var groot = knop.dataset.kmFotoAchterGroot || achter;
      tweede.setAttribute('srcset', achter + ' 533w, ' + groot + ' 1066w');
      tweede.setAttribute('src', achter);
      tweede.classList.remove('km-kaart-kleuren__zonder-achterkant');
    } else {
      tweede.classList.add('km-kaart-kleuren__zonder-achterkant');
    }
  }

  function wisselLinks(kaart, knop) {
    var variant = knop.dataset.kmVariant;
    if (!variant) return;

    kaart.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var adres = link.getAttribute('href');
      if (!adres) return;
      // Een eerder gekozen kleur eruit halen, dan de nieuwe erin zetten.
      adres = adres.replace(/([?&])variant=\d+/, '$1').replace(/[?&]$/, '');
      var scheiding = adres.indexOf('?') === -1 ? '?' : '&';
      link.setAttribute('href', adres + scheiding + 'variant=' + variant);
    });
  }

  function zetActief(kaart, knop) {
    kaart.querySelectorAll('[data-km-kleur-knop]').forEach(function (k) {
      var actief = k === knop;
      k.classList.toggle('km-kaart-kleuren__knop--actief', actief);
      k.setAttribute('aria-pressed', actief ? 'true' : 'false');
    });
  }

  // Uit een adres alleen de bestandsnaam halen, zonder ?v= en zonder maat-parameters.
  function bestandsnaam(adres) {
    if (!adres) return '';
    var zonderVraag = adres.split('?')[0];
    return zonderVraag.substring(zonderVraag.lastIndexOf('/') + 1);
  }

  // Bij het openen van de pagina het rondje aanwijzen dat hoort bij de foto die het
  // kaartje toont. De eerste kleur in de lijst is namelijk niet per se de kleur op
  // de productfoto.
  function wijsBeginkleurAan() {
    document.querySelectorAll('[data-km-kaart-kleuren]').forEach(function (rij) {
      if (rij.dataset.kmBeginkleur === 'klaar') return;
      rij.dataset.kmBeginkleur = 'klaar';

      var kaart = kaartVan(rij);
      if (!kaart) return;

      var afbeelding = kaart.querySelector('.card__media img');
      if (!afbeelding) return;

      var huidige = bestandsnaam(afbeelding.currentSrc || afbeelding.getAttribute('src'));
      if (!huidige) return;

      var treffer = null;
      rij.querySelectorAll('[data-km-kleur-knop]').forEach(function (knop) {
        if (!treffer && bestandsnaam(knop.dataset.kmFoto) === huidige) treffer = knop;
      });

      if (treffer) {
        zetActief(kaart, treffer);
        wisselAchterkant(kaart, treffer);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-km-kleur-knop]');
    if (!knop) return;

    // De knopjes zitten binnen een kaartje dat zelf een link is; niet doorklikken.
    event.preventDefault();
    event.stopPropagation();

    var kaart = kaartVan(knop);
    if (!kaart) return;

    wisselFoto(kaart, knop);
    wisselAchterkant(kaart, knop);
    wisselLinks(kaart, knop);
    zetActief(kaart, knop);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wijsBeginkleurAan);
  } else {
    wijsBeginkleurAan();
  }

  // Kaartjes komen niet altijd met de pagina mee: na filteren of van weergave wisselen
  // bouwt het thema het raster opnieuw op, en "Gerelateerde producten" wordt pas ná het
  // laden binnengehaald. Daarom kijken we de hele pagina na op nieuwe rijen bolletjes.
  if (window.MutationObserver) {
    var wachtend = null;
    new MutationObserver(function () {
      window.clearTimeout(wachtend);
      wachtend = window.setTimeout(wijsBeginkleurAan, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
